import { useState } from "react";
import "../styles/components.scss";

const SelectComponent = ({ label, value, onChange, name, options }) => {
  const [isFocused, setIsFocused] = useState(false);

  const shouldFloat = isFocused || value;

  return (
    <div
      className={`roi--floating-input-container ${
        shouldFloat ? "focused" : ""
      }`}
    >
      <label
        className={`roi--floating-label ${shouldFloat ? "roi--float" : ""}`}
        htmlFor={name}
      >
        {label}
      </label>
      <select
        id={name}
        name={name}
        value={value || ""}
        onChange={onChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        className="roi--floating-select"
      >
        <option value="" disabled hidden></option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectComponent;
